import { useEffect, useState } from "react";
import { useAsync } from "../../../utils/hooks/useAsync";
import { AdminService } from "../utils";
import "./ListVariations.scss";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Collapsible from "react-collapsible";
import Label from "../../Label";
import { displayMoney } from "../../../utils/displayMoney";
import { normalizeWastage } from "../../../utils/wastage";

type Props = {
  Variations: Variation[];
  manufacturingCost: ManufacturingCost[];
  isSolid: boolean;
  department: string;
  material: string;
};

const ListVariations: React.FC<Props> = ({
  Variations,
  manufacturingCost,
  isSolid,
  department,
  material,
}) => {
  const wastageLabel = (value?: Wastage) => {
    if (value === "NO_WASTAGE") {
      return "Sin merma";
    }
    return value || "825";
  };
  const { run } = useAsync();
  const [modified, setModified] = useState<boolean>(false);
  const [modifiedVariations, setModifiedVariations] =
    useState<Variation[]>(Variations);
  const [groupedVariations, setGroupedVariations] =
    useState<groupedVariationsType>([]);
  const collapsible = (gauge: string) => (
    <div className="trigger">
      <p>{gauge}</p>
    </div>
  );
  useEffect(() => {
    setModifiedVariations(Variations);
  }, [Variations]);

  useEffect(() => {
    let auxGroupedVariations: groupedVariationsType = [];
    modifiedVariations.map((variation) => {
      let index = auxGroupedVariations.findIndex(
        (el) => el.gauge == variation.gauge
      );
      if (index >= 0) {
        auxGroupedVariations[index].variations.push(variation);
      } else {
        let aux: Variation[] = [];
        aux.push(variation);
        auxGroupedVariations.push({
          gauge: variation.gauge,
          variations: aux,
        });
      }
    });

    setGroupedVariations(
      auxGroupedVariations.sort(
        (el, el2) =>
          Number(el.gauge.replaceAll(",", "")) -
          Number(el2.gauge.replaceAll(",", ""))
      )
    );
  }, [modifiedVariations]);

  const handleChange = (e: any, id?: string) => {
    setModified(true);
    setModifiedVariations(
      modifiedVariations.map((el) =>
        el._id == id
          ? { ...el, [e.currentTarget.name]: e.currentTarget.value }
          : el
      )
    );
  };

  const handleDelete = (data: Variation) => {
    run(
      AdminService.deleteVariation(data).then((r: any) => {
        toast.success("Variación eliminada");
        setModifiedVariations(
          modifiedVariations.filter((el) => el._id != data._id)
        );
      })
    );
  };

  const SaveVariations = () => {
    let deltas: Variation[] = [];
    for (let index = 0; index < modifiedVariations.length; index++) {
      JSON.stringify(modifiedVariations[index]) !=
        JSON.stringify(Variations[index]) &&
        deltas.push(modifiedVariations[index]);
    }
    const normalizedDeltas = deltas.map((vari) => ({
      ...vari,
      wastage: normalizeWastage(vari.wastage, material),
    }));
    run(
      AdminService.updateVariations(normalizedDeltas).then((data) => {
        setModified(false);
        data.data.nModified > 0 && toast.success("Modificaciones guardadas");
      })
    );
  };
  return (
    <div className="listVariationsContainer">
      <ToastContainer autoClose={1500} position={"bottom-left"} />

      {groupedVariations &&
        groupedVariations.map((gvar) => {
          return (
            <>
              <Collapsible
                className="resultsAddVariationHeader"
                triggerOpenedClassName="resultsAddVariationHeader"
                triggerWhenOpen={collapsible("∧  " + gvar.gauge)}
                trigger={collapsible("∨  " + gvar.gauge)}
              >
                <div className="resultsAddVariationItems">
                  {(department == "chain" || department == "brazalete") &&
                  isSolid ? (
                    <Label
                      tag="h3"
                      style={{
                        fontFamily: "Mont-Light",
                        fontSize: "12px",
                        textAlign: "start",
                        width: "20%",
                      }}
                    >
                      LARGO
                    </Label>
                  ) : (
                    <Label
                      tag="h3"
                      style={{
                        fontFamily: "Mont-Light",
                        fontSize: "12px",
                        textAlign: "start",
                        width: "20%",
                      }}
                    >
                      MEDIDAS
                    </Label>
                  )}
                  <Label
                    tag="h3"
                    style={{
                      fontFamily: "Mont-Light",
                      fontSize: "12px",
                      textAlign: "start",
                      width: "20%",
                      marginRight: " 3px",
                      marginLeft: "3px",
                      paddingRight: "2px",
                    }}
                  >
                    PESO
                  </Label>
                  <Label
                    tag="h3"
                    style={{
                      fontFamily: "Mont-Light",
                      fontSize: "12px",
                      textAlign: "start",
                      width: "20%",
                      marginRight: "3px",
                      marginLeft: "3px",
                      paddingRight: "2px",
                    }}
                  >
                    HECHURA
                  </Label>
                  <Label
                    tag="h3"
                    style={{
                      fontFamily: "Mont-Light",
                      fontSize: "12px",
                      textAlign: "start",
                      width: "20%",
                    }}
                  >
                    COLOR
                  </Label>
                  <Label
                    tag="h3"
                    style={{
                      fontFamily: "Mont-Light",
                      fontSize: "12px",
                      textAlign: "start",
                      width: "20%",
                      marginRight: "3px",
                      marginLeft: "3px",
                      paddingRight: "2px",
                    }}
                  >
                    MERMA
                  </Label>

                  <p
                    style={{
                      textAlign: "end",
                      textDecoration: "underline",
                      marginRight: 10,
                      width: "20%",
                    }}
                  ></p>
                </div>
                {gvar.variations.map((vari) => {
                  return (
                    <div
                      className="resultsAddVariationItems"
                      key={
                        vari.productId + vari.gauge + vari.length + vari.color
                      }
                    >
                      <p>
                        {vari.length}{" "}
                        {(department == "chain" || department == "brazalete") &&
                        isSolid
                          ? "cm"
                          : "mm"}
                      </p>
                      <input
                        className="weight"
                        type="text"
                        name="weight"
                        onChange={(e) => handleChange(e, vari._id)}
                        defaultValue={vari.weight + " gr"}
                      ></input>
                      <select
                        className="manufacturingCost"
                        name="manufacturingCostId"
                        onClick={(e) => handleChange(e, vari._id)}
                        onChange={(e) => handleChange(e, vari._id)}
                        value={vari.manufacturingCostId}
                      >
                        {manufacturingCost &&
                          manufacturingCost.map((man) => {
                            if (vari.color == "plata") {
                              if (man.material == "silver") {
                                return (
                                  <option key={man.title} value={man._id}>
                                    {man.description}
                                  </option>
                                );
                              }
                            } else {
                              if (man.material == "gold") {
                                return (
                                  <option key={man.title} value={man._id}>
                                    {man.description +
                                      " - " +
                                      displayMoney(man.value)}
                                  </option>
                                );
                              }
                            }
                          })}
                      </select>

                      <p>
                        {vari.color.charAt(0).toUpperCase() +
                          vari.color.slice(1)}
                      </p>
                      <p>{wastageLabel(vari.wastage)}</p>
                      <p
                        onClick={() => handleDelete(vari)}
                        style={{
                          textAlign: "end",
                          textDecoration: "underline",
                          marginRight: 10,
                        }}
                        className="deleteButton"
                      >
                        Borrar
                      </p>
                    </div>
                  );
                })}
              </Collapsible>
            </>
          );
        })}
      {modified && (
        <div className="saveVariationButtonContainer">
          <button
            type="button"
            className="save_variations"
            onClick={SaveVariations}
          >
            Grabar Modificaciones
          </button>
        </div>
      )}
    </div>
  );
};

export default ListVariations;
